/** @format */

/* eslint react-hooks/rules-of-hooks: "warn" -- Legacy code: do not use as an example. */
import React, { Fragment, ReactNode } from 'react';

import { useMounted } from '@toucan/client/shared/hooks/use-mounted';

import { MetaFactory } from '@toucan/client/features/seo';

type GetMetaElementsProps = {
    factory: MetaFactory;
    /**
     * Ignore the mounted check - useful for SSR pages that should add meta elements on the first render
     */
    // eslint-disable-next-line @typescript-eslint/naming-convention -- Legacy code: do not use as an example.
    ignoreMount?: boolean;
};

export const getMetaElements = ({
    factory,
    ignoreMount = false,
}: GetMetaElementsProps): ReactNode => {
    const mounted = useMounted();

    function getMeta(): ReactNode {
        if (!mounted() && !ignoreMount) {
            return null;
        }

        const { title, description } = factory.getMeta();

        return (
            <Fragment>
                <title data-testid="head__page-title">{title}</title>
                <meta
                    name="description"
                    data-testid="head__page-description"
                    content={description}
                />
            </Fragment>
        );
    }

    return getMeta();
};
